import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { loadConfig } from "./config";

function setupAnalytics() {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_ENV !== "test"
  ) {
    console.log(process.env.REACT_APP_ENV);

    // Silence console in prod
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-EYZMP7R3ZE";
    document.head.appendChild(script);

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-EYZMP7R3ZE');
    `;
    document.head.appendChild(inlineScript);
  }
}

async function bootstrap() {
  try {
    // Ensure config loads BEFORE anything uses it
    await loadConfig();
    console.log("App config loaded successfully");
  } catch (err) {
    console.error("Config failed to load, app continuing with defaults", err);
  }

  setupAnalytics();

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  reportWebVitals();
}

bootstrap();
